module.exports = __webpack_public_path__ + "static/media/white_logo.48933c50.png";